import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import GoogleAnalytics from '../../../util/Ga.js';

// ES6 class-style
class WhoBanner extends PreLoginSessionCheck {
  render() {
	  
  	return(
	<section className="bg-grn why-us">
		<div className="container"> 
			<h1>We are a bunch of folks who are zealously driven to make the learning of Math creative and enjoyable for students</h1> 
			<h2>Nothing excites us more than a student saying ‘Aah, I get it now’!</h2>
		</div> 
	</section>
  	);
  }
}

export default WhoBanner; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/WhoBanner.js